import React from 'react';
import { motion } from 'framer-motion';
const FINDINGS = [{
  stat: '3 mo.',
  label: 'Field testing',
  body: 'Every flagged product was assessed over a minimum three-month period against measured, real-world conditions.'
}, {
  stat: '7',
  label: 'Scoring dimensions',
  body: 'Products are scored across performance, reliability, support, transparency, value and long-term ownership.'
}, {
  stat: '94/100',
  label: 'Top Trust Score',
  body: 'The highest-verified system in this report earned a 94 Agreexa Trust Score® after full editorial approval.'
}, {
  stat: '0',
  label: 'Paid placements',
  body: 'No manufacturer paid for inclusion or ranking. Affiliate relationships never influence a score.'
}];
export function KeyFindings() {
  return <section className="w-full bg-ink text-paper" data-id="element-82">
      <div className="max-w-editorial mx-auto px-6 py-16 md:py-20" data-id="element-83">
        <p className="eyebrow text-trust-300 mb-8" data-id="element-84">Key Findings at a Glance</p>
        <div className="grid gap-px bg-stone-800 sm:grid-cols-2 lg:grid-cols-4 rounded-sm overflow-hidden border border-stone-800" data-id="element-85">
          {FINDINGS.map((f, i) => <motion.div key={f.label} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.08
        }} className="bg-ink p-7" data-id="element-86">
              <p className="font-serif text-4xl tracking-tightest text-paper" style={{
            fontWeight: 500
          }} data-id="element-87">
                {f.stat}
              </p>
              <p className="eyebrow text-trust-300 mt-2 mb-3" data-id="element-88">{f.label}</p>
              <p className="text-sm text-stone-400 leading-relaxed" data-id="element-89">{f.body}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}